module.exports = __webpack_public_path__ + "static/media/o_configurator_tablet.c705e74f.jpg";